module.exports = __webpack_public_path__ + "img/homebgc.51928b3d.png";